import { fetch } from '@atlassian/eoc-fetch';
import { urls } from '../../../common/constants';
const getStatus = () => {
  return fetch(urls.wioc.status.url(), {
    method: 'GET'
  });
};
export { getStatus };